import { createAction } from '@reduxjs/toolkit';
import { SET_FOOTER_LABELS, SET_SOCIAL_LINKS } from './actionTypes';
export const setSocialLinks = createAction(SET_SOCIAL_LINKS);
export const setFooterLabels = createAction(SET_FOOTER_LABELS);
